import React from 'react';
import { Helmet } from 'react-helmet';

export default function TermsOfService() {
  return (
    <>
      <Helmet>
        <title>Terms of Service - EduConnect</title>
        <meta name="description" content="Terms of Service for EduConnect platform" />
      </Helmet>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-indigo max-w-none">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using EduConnect, you accept and agree to be bound by the terms
            and provision of this agreement.
          </p>

          <h2>2. User Registration</h2>
          <p>
            To use certain features of the platform, you must register for an account.
            You agree to provide accurate information and keep it updated.
          </p>

          <h2>3. Student and Teacher Conduct</h2>
          <p>
            All users must conduct themselves professionally and respectfully.
            Any form of harassment or inappropriate behavior will result in account termination.
          </p>

          <h2>4. Booking and Payments</h2>
          <p>
            Teachers set their own rates. Students must pay for confirmed bookings.
            Cancellation policies apply as described in the booking terms.
          </p>

          <h2>5. Content Guidelines</h2>
          <p>
            Users are responsible for the content they post. Inappropriate, illegal,
            or harmful content is prohibited and will be removed.
          </p>

          <h2>6. Privacy</h2>
          <p>
            We collect and use personal information as described in our Privacy Policy.
            By using EduConnect, you agree to our data practices.
          </p>

          <h2>7. Intellectual Property</h2>
          <p>
            EduConnect and its original content are protected by copyright and other laws.
            Our trademarks and trade dress may not be used without written permission.
          </p>

          <h2>8. Termination</h2>
          <p>
            We reserve the right to terminate or suspend accounts that violate these terms
            or for any other reason at our discretion.
          </p>

          <h2>9. Changes to Terms</h2>
          <p>
            We may modify these terms at any time. Continued use of the platform after
            changes constitutes acceptance of the new terms.
          </p>

          <h2>10. Contact Information</h2>
          <p>
            For questions about these Terms of Service, please contact us at{' '}
            <a href="mailto:legal@educonnect.com" className="text-indigo-600 hover:text-indigo-500">
              legal@educonnect.com
            </a>
          </p>
        </div>

        <div className="mt-8 text-sm text-gray-500">
          Last updated: March 19, 2025
        </div>
      </div>
    </>
  );
}